import React from 'react'
import Page from '../../../../components/Page'
import { features } from './data'
import styles from './styles'

// material
import {
  withStyles,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  CircularProgress,
} from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { CoreButton } from 'src/components/core'
import { TableHeadComponent, TableRowComponent } from './components'

const ButtonCell = styled(TableCell)(() => ({
  backgroundColor: '#fff',
  textAlign: 'center',
  borderBottom: 'none',
  padding: '24px 8px 16px',
}))

const TableInvoice = props => {
  const { plans, handleClick, classes, loading } = props
  const filteredPlans = plans.filter(item => !item.isAllPlansInclude)
  const activeKeys = filteredPlans.map(item => item.key)

  return (
    <Page className={classes.rootStyle}>
      <TableContainer className={classes.tableContainer} component={Paper}>
        <Table className={classes.table}>
          {/* Plan names header */}
          <TableHead className={classes.stickyHead}>
            <TableRow>
              <TableCell className={classes.planHeaderCellWide} />
              {filteredPlans.map(item => (
                <TableCell key={item.key} className={classes.planHeaderCell}>
                  {item.subscription}
                </TableCell>
              ))}
            </TableRow>
            {/* Buttons row */}
            <TableRow>
              <ButtonCell className={classes.buttonCellWide} />
              {filteredPlans.map(item => (
                <ButtonCell key={item.key}>
                  {/* Enterprise plans check out their underlying subscription
                      here; the demo call lives on the plan card. */}
                  {(item.upgradeAction || item.action) &&
                    (() => {
                      const act = item.upgradeAction || item.action
                      return (
                        <CoreButton
                          fullWidth
                          size="large"
                          color={act.active ? 'secondary' : 'primary'}
                          variant={act.active ? 'outlined' : 'contained'}
                          className={
                            !act.active ? classes.upgradeButtonStyle : undefined
                          }
                          disabled={act.disabled === true || loading}
                          onClick={() => handleClick(item)}
                        >
                          {loading && act.disabled !== true ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            act.tableText || act.text
                          )}
                        </CoreButton>
                      )
                    })()}
                </ButtonCell>
              ))}
            </TableRow>
          </TableHead>
          {/* Categories and features */}
          <TableBody>
            {features.map(category => (
              <React.Fragment key={category.category}>
                <TableHeadComponent
                  category={category}
                  activeKeys={activeKeys}
                  classes={classes}
                />
                {category.options.map(row => (
                  <TableRowComponent
                    key={row.name}
                    row={row}
                    activeKeys={activeKeys}
                    classes={classes}
                  />
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Page>
  )
}

export default withStyles(styles)(TableInvoice)
